import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-modern-drawer/dist/index.css';
import App from './App';
import './index.css';

import { Buffer as BufferPolyfill } from 'buffer';
declare var Buffer: typeof BufferPolyfill;
(window as any).Buffer = (window as any).Buffer || BufferPolyfill;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
